import React, { Component } from 'react'
import IconHexagon from 'components/icons/hexagon-solid'

import './Summary.scss'
import colors from 'styles/_exports.module.scss';

import Tip2 from './img/tip2.svg'
import Tip3 from './img/tip3.svg'
import Tip4 from './img/tip4.svg'

import { withTranslation } from 'react-i18next'

class Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    render() {
        return (
          <div className="Summary">
              <div>
                  <p className="description" tabIndex={0}>{this.props.t("It is always good to summarize your methodology and observations after you have completed an experiment. Please view a recap of this simulation and takeaway messages regarding micropipetting below.")}</p>
                  <div className="learning-objectives">
                    <h5 tabIndex={0}>{this.props.t("In this simulation, you learned the correct way to use a micropipette in a lab. This is a crucial technique that is used frequently in molecular biology. The simulation explored how to:")}</h5>
                    <ul>
                      <li>
                        <div className="index">
                          <IconHexagon
                            style={{ color: ((this.props.current) ? "white" : ((this.props.complete) ? colors.navy3 : colors.navy1)), height: '18px' }}
                          />
                        </div>
                        <span tabIndex={0}>{this.props.t("Set the volume on a micropipette.")}</span>
                      </li>
                      <li>
                        <div className="index">
                          <IconHexagon
                            style={{ color: ((this.props.current) ? "white" : ((this.props.complete) ? colors.navy3 : colors.navy1)), height: '18px' }}
                          />
                        </div>
                        <span tabIndex={0}>{this.props.t("Attach a tip to the micropipette.")}</span>
                      </li>
                      <li>
                        <div className="index">
                          <IconHexagon
                            style={{ color: ((this.props.current) ? "white" : ((this.props.complete) ? colors.navy3 : colors.navy1)), height: '18px' }}
                          />
                        </div>
                        <span tabIndex={0}>{this.props.t("Use the plunger to draw up liquid (press to first stop).")}</span>
                      </li>
                      <li>
                        <div className="index">
                          <IconHexagon
                            style={{ color: ((this.props.current) ? "white" : ((this.props.complete) ? colors.navy3 : colors.navy1)), height: '18px' }}
                          />
                        </div>
                        <span tabIndex={0}>{this.props.t("Use the plunger to expel liquid (press to second stop).")}</span>
                      </li>
                      <li>
                        <div className="index">
                          <IconHexagon
                            style={{ color: ((this.props.current) ? "white" : ((this.props.complete) ? colors.navy3 : colors.navy1)), height: '18px' }}
                          />
                        </div>
                        <span tabIndex={0}>{this.props.t("Discard the micropipette tip after use.")}</span>
                        </li>
                    </ul>
                  </div>
                  <div className="tips">
                    <h5 tabIndex={0}>{this.props.t("Takeaway messages")}</h5>
                    <ul>
                      <li>
                        <img tabIndex={0} src={Tip2} alt={this.props.t('Closed tip box.')} />
                        <div className="tip">
                          <p tabIndex={0}>{this.props.t("Always remember to close tip boxes when you are done to prevent contamination.")}</p>
                        </div>
                      </li>
                      <li>
                        <img tabIndex={0} src={Tip3} alt={this.props.t('Pipette on rack.')} />
                        <div className="tip">
                          <p tabIndex={0}>{this.props.t("Never place a micropipette with liquid drawn up back on the rack.")}</p>
                        </div>
                      </li>
                      <li>
                        <img tabIndex={0} src={Tip4} alt={this.props.t('Ejected micropipette tip.')} />
                        <div className="tip">
                          <p tabIndex={0}>{this.props.t("Always dispose of micropipette tips in the trash when you are done.")}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
              </div>
          </div>
        );
    }
}

export default withTranslation()(Summary);
